// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module__container___20N-o","title":"styles-module__title___wsD5_","coordinates":"styles-module__coordinates___2Hp2k"};